module.exports = __webpack_public_path__ + "static/CircularPro-MediumItalic.514849d6.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-MediumItalic.woff2
// module id = 656
// module chunks = 168707334958949